<template>
  <div>
    <CityManagement />
    <CooperationManagement />
  </div>
</template>

<script>
import CityManagement from "./components/CityMenagement";
import CooperationManagement from "./components/CooperationManagement";
export default {
  components: {
    CityManagement,
    CooperationManagement,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/iHeritage/cityManagement.vue